<template>
  <div class="BASFspinner" :class="{ 'BASFspinner--fixed': fullScreen }">
    <div class="BASFspinner__loader"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Spinner',
  props: {
    fullScreen: {
      type: Boolean,
      default: false
    }
  }
});
</script>

<style lang="scss" scoped>
.BASFspinner {
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;

  &--fixed {
    position: fixed;
  }

  &__loader {
    transform: rotate(-90deg);
    &:before {
      display: block;
      border: 12px solid $corporate;
      width: 40px;
      height: 40px;
      content: '';
      animation-name: box;
      animation-duration: 1.5s;
      animation-iteration-count: infinite;
    }
    &:after {
      display: block;
      margin: 11px;
      background: $corporate;
      width: 18px;
      height: 18px;
      content: '';
      animation-name: dot;
      animation-duration: 1.5s;
      animation-iteration-count: infinite;
    }
  }
}

@keyframes box {
  0% {
    transform: translate(0px, 0px);
  }
  25% {
    transform: translate(0px, 0px);
  }
  50% {
    transform: translate(0px, 40px);
  }
  75% {
    transform: translate(0px, 40px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
@keyframes dot {
  0% {
    transform: translate(0px, 0px);
  }
  25% {
    transform: translate(0px, -40px);
  }
  50% {
    transform: translate(0px, 0px);
  }
  75% {
    transform: translate(0px, -40px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
</style>
